import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';

const ArticleGrid = () => {
  const [selectedDocument, setSelectedDocument] = React.useState(null);

  const articles = [
  {
    id: 3,
    title: "Machine Learning pour les PME Africaines",
    excerpt: "Comment les petites et moyennes entreprises peuvent tirer parti du machine learning pour optimiser leurs opérations.",
    author: "Dr. Fatima Ndiaye",
    readTime: "6 min",
    category: "Intelligence Artificielle",
    categoryColor: "burgundy",
    publishedDate: "4 Nov 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10205f4b5-1767082355746.png",
    alt: "Écran d'ordinateur montrant des graphiques de machine learning et des données analytiques pour les entreprises africaines",
    slug: "/machine-learning-pme-africaines"
  },
  {
    id: 4,
    title: "Formation IA : Méthodologies Innovantes",
    excerpt: "Découvrez les nouvelles approches pédagogiques pour former efficacement vos équipes aux technologies IA.",
    author: "Pr. Jean-Baptiste Kone",
    readTime: "10 min",
    category: "Développement des Compétences",
    categoryColor: "gold",
    publishedDate: "3 Nov 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1588a9ae3-1767082357565.png",
    alt: "Salle de formation moderne avec des participants africains apprenant l'intelligence artificielle sur des tablettes interactives",
    slug: "/formation-ia-methodologies"
  },
  {
    id: 5,
    title: "IA et Éthique : Guide Pratique",
    excerpt: "Les considérations éthiques essentielles lors de l'implémentation de solutions d'Intelligence Artificielle.",
    author: "Dr. Aisha Traore",
    readTime: "8 min",
    category: "Intelligence Artificielle",
    categoryColor: "burgundy",
    publishedDate: "2 Nov 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1079e1fdd-1764661382289.png",
    alt: "Concept d'éthique en intelligence artificielle avec des symboles de balance et de justice sur fond technologique",
    slug: "/ia-ethique-guide-pratique"
  },
  {
    id: 6,
    title: "Transformation Digitale : Cas d\'Étude",
    excerpt: "Analyse détaillée d\'une transformation digitale réussie dans une entreprise manufacturière ivoirienne.",
    author: "M. David Ouattara",
    readTime: "12 min",
    category: "Transformation Digitale",
    categoryColor: "amber",
    publishedDate: "1 Nov 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f489626b-1767082356903.png",
    alt: "Usine moderne en Côte d\'Ivoire avec des écrans numériques et des systèmes automatisés illustrant la transformation digitale",
    slug: "/transformation-digitale-cas-etude"
  },
  {
    id: 7,
    title: "Chatbots Intelligents : ROI et Impact",
    excerpt: "Mesurer l\'impact des chatbots IA sur la satisfaction client et la productivité dans le contexte africain.",
    author: "Mme. Mariam Diop",
    readTime: "7 min",
    category: "Intelligence Artificielle",
    categoryColor: "burgundy",
    publishedDate: "31 Oct 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b71551de-1766565517422.png",
    alt: "Interface de chatbot intelligent sur smartphone avec bulles de conversation et icônes d'intelligence artificielle",
    slug: "/chatbots-intelligents-roi-impact"
  },
  {
    id: 8,
    title: "Leadership à l\'Ère de l\'IA",
    excerpt: "Comment développer les compétences de leadership nécessaires pour diriger dans un monde dominé par l'IA.",
    author: "Dr. Samuel Mensah",
    readTime: "9 min",
    category: "Développement des Compétences",
    categoryColor: "gold",
    publishedDate: "30 Oct 2025",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17fa25028-1766507296938.png",
    alt: "Leader africain présentant des stratégies d'intelligence artificielle à son équipe dans une salle de conférence moderne",
    slug: "/leadership-ere-ia"
  }];


  const getCategoryColorClasses = (color) => {
    const colorMap = {
      burgundy: "bg-[#96121D]/10 text-[#96121D] border border-[#96121D]/20",
      gold: "bg-[#9B8E57]/10 text-[#9B8E57] border border-[#9B8E57]/20",
      amber: "bg-amber-50 text-amber-700 border border-amber-200"
    };
    return colorMap?.[color] || "bg-gray-100 text-gray-800";
  };

  return (
    <section id="articles" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#9B8E57]/10 text-[#9B8E57] text-sm font-semibold mb-4 border border-[#9B8E57]/20">
            <span className="w-2 h-2 bg-[#96121D] rounded-full mr-2 animate-pulse"></span>
            Nos Publications
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Articles <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#96121D] to-[#9B8E57]">Récents</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Restez à jour avec nos dernières publications sur l'IA, la transformation digitale et le développement des compétences
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles?.map((article) =>
          <Link
            key={article?.id}
            to={article?.slug}
            className="group bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-[#9B8E57]/30">

              {/* Article Image */}
              <div className="relative h-52 overflow-hidden">
                <Image
                src={article?.image}
                alt={article?.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold backdrop-blur-sm ${getCategoryColorClasses(article?.categoryColor)}`}>
                    {article?.category}
                  </span>
                </div>

                {/* Read Time */}
                <div className="absolute bottom-4 right-4">
                  <span className="px-3 py-1.5 bg-black/60 backdrop-blur-sm text-white text-xs rounded-lg font-medium border border-white/20">
                    {article?.readTime}
                  </span>
                </div>
              </div>

              {/* Article Content */}
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <svg className="w-4 h-4 mr-2 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span>{article?.publishedDate}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#96121D] transition-colors duration-300 line-clamp-2">
                  {article?.title}
                </h3>

                <p className="text-gray-600 mb-5 text-sm leading-relaxed line-clamp-3">
                  {article?.excerpt}
                </p>

                {/* CTA Button for Machine Learning Article */}
                {article?.id === 3 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1XCHErvq9VwlSomXvnFOqB5nEv2hyp_03vR9xOdyoqEs/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }

                {/* CTA Button for Formation IA Article */}
                {article?.id === 4 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1mbbLV3nmcKeGsM3Mg1CbpMXqTB2r2pC6sB3sFEeTcP8/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }

                {/* CTA Button for IA et Éthique Article */}
                {article?.id === 5 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1RKbW04HbpKYH53V9gGFUhui0I_3MGuLNvLzCdx3XNRA/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }

                {/* CTA Button for Transformation Digitale Article */}
                {article?.id === 6 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1DGlThRqIi8U-I46hFbN5ip0MukOAQAX1ou3KanI0oyk/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }

                {/* CTA Button for Chatbots Intelligents Article */}
                {article?.id === 7 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1lY0_YRp2IKy8Or9DChc9gZRNQ0ZBiB41ffl5Tu4RwQ8/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }

                {/* CTA Button for Leadership à l'Ère de l'IA Article */}
                {article?.id === 8 &&
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setSelectedDocument('https://docs.google.com/document/d/1la6G7zT-_tQNOP6NqJxoswUMsZmUWrVNp1k1rqnNu4E/preview');
                }}
                className="inline-flex items-center px-4 py-2 mb-4 bg-gradient-to-r from-[#96121D] to-[#9B8E57] text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105">

                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Lire le Document Complet
                  </button>
              }
              </div>
            </Link>
          )}
        </div>

        {/* Load More */}
        <div className="text-center mt-16">
          <button className="px-10 py-4 bg-white border-2 border-[#96121D] text-[#96121D] font-bold rounded-xl hover:bg-[#96121D] hover:text-white transition-all duration-300 shadow-md hover:shadow-xl">
            Charger Plus d'Articles
          </button>
        </div>
      </div>
      {/* Document Viewer Modal */}
      {selectedDocument && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
          onClick={() => setSelectedDocument(null)}
        >
          <div 
            className="relative w-full h-full max-w-6xl max-h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden"
            onClick={(e) => e?.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedDocument(null)}
              className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors duration-200"
              aria-label="Fermer"
            >
              <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Document Iframe */}
            <iframe
              src={selectedDocument}
              className="w-full h-full"
              title="Document Viewer"
              frameBorder="0"
            />
          </div>
        </div>
      )}
    </section>
  );


};

export default ArticleGrid;